import React from "react"
import { useTranslation } from "react-i18next";
import {BiChevronsLeft,BiChevronLeft,BiChevronsRight,BiChevronRight} from 'react-icons/bi'
import PropTypes from 'prop-types';


const Pagination = (
    {
        gotoPage,
        setPageSize, pageSize,
        canPreviousPage, canNextPage,
        previousPage, nextPage,
        pageIndex, pageCount, pageOptions
    }
) => {
    const { t } = useTranslation();

    const pagesOptions = [
        { value: '10', label: ' 10' },
        { value: '20', label: ' 20' },
        { value: '30', label: ' 30' },
        { value: '40', label: ' 40' },
        { value: '50', label: ' 50' },
    ]

    const onChangeInSelect = event => {
        setPageSize(Number(event.target.value))
    }



    return (


        <div className=" flex flex-row py-2 text-sm justify-between items-center flex-1">
            <div className="flex items-center ">
                <span className="mr-4">Page{" "}<strong> {pageIndex + 1} {t('pagination.of')} {pageOptions.length}</strong>   </span>
                <select
                    className="mt-1 block h-10 text-xs rounded border-gray-300  focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                    value={pageSize}
                    onChange={onChangeInSelect}
                >
                    {pagesOptions.map((p) => (
                        <option key={p.label} value={p.value} >
                            {t('actions.show')+p.label}
                        </option>
                    ))}
                </select>

            </div>

            <div className="text-lg text-gray-600 ">
                <button
                    className="bg-gray-100 border mr-2 p-2 rounded-sm hover:bg-gray-200 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-gray-100"
                    onClick={() => gotoPage(0)}
                    disabled={!canPreviousPage}
                >
                    <span className="sr-only">{t('pagination.first')}</span>
                    <BiChevronsLeft />
                </button>
                
                <button
                    className="bg-gray-100 border   mr-2 p-2 rounded-sm hover:bg-gray-200"
                    onClick={previousPage}
                    disabled={!canPreviousPage}
                >
                    <span className="sr-only">{t('pagination.previous')}</span>
                    <BiChevronLeft />
                </button>

                <button className="bg-gray-100 border mr-2 p-2 rounded-sm hover:bg-gray-200 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-gray-100" onClick={nextPage} disabled={!canNextPage}>
                    <span className="sr-only">{t('pagination.next')}</span>
                    <BiChevronRight />
                </button>

                <button
                    className="bg-gray-100 border p-2 rounded-sm hover:bg-gray-200 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-gray-100" disabled={!canNextPage}
                    onClick={() => gotoPage(pageCount - 1)}
                >
                    <span className="sr-only">{t('pagination.last')}</span>
                    <BiChevronsRight />
                </button>
            </div>


            {/* <div>
                <input
                    type="number"
                    min={1}
                    className="p-0 text-xs w-16 rounded-md border-transparent appearance-none border border-gray-300 bg-white text-gray-700 placeholder-gray-400  focus:outline-none focus:ring-2 focus:ring-indigo-500-600 focus:border-transparent"
                    max={pageOptions.length}
                    defaultValue={pageIndex + 1}
                    onChange={onChangeInInput}
                />
            </div> */}

        </div>

    );
}

Pagination.propTypes = {
  gotoPage: PropTypes.func.isRequired,
  setPageSize: PropTypes.func.isRequired,
  pageSize: PropTypes.number.isRequired,
  canPreviousPage: PropTypes.bool.isRequired,
  canNextPage: PropTypes.bool.isRequired,
  previousPage: PropTypes.func.isRequired,
  nextPage: PropTypes.func.isRequired,
  pageIndex: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
  pageOptions: PropTypes.array.isRequired,
};

export default Pagination;
